'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { getCookieValue } from './utils';
const WORDPRESS_ACTIVE_SESSION = 'wordpress_session_active';
export const useHasWPSession = () => {
  const $ = _c(4);
  const [hasWPSession, setHasWPSession] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setHasWPSession(getCookieValue(WORDPRESS_ACTIVE_SESSION) === "1");
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== hasWPSession) {
    t2 = {
      hasWPSession
    };
    $[2] = hasWPSession;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};